/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveTerminals from './receive-terminals';

export default () => (dispatch) => {
    dispatch({
        type: actions.TERMINALS_REQUEST,
    });

    return cecSdk
        .terminal()
        .getTerminals()
        .then((terminals) => {
            dispatch({
                type: actions.TERMINALS_REQUEST_SUCCESS,
            });
            
            dispatch(receiveTerminals(terminals));

            return terminals;
        })
        .catch((e) => {
            dispatch({ type: actions.TERMINALS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
